import { render, staticRenderFns } from "./IDCard.vue?vue&type=template&id=7f916c5c"
import script from "./IDCard.vue?vue&type=script&lang=js"
export * from "./IDCard.vue?vue&type=script&lang=js"
import style0 from "./IDCard.vue?vue&type=style&index=0&id=7f916c5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports